module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Map/Position-49df699e037dbe17301da5715cf298f0eea5ba105e511d667eb6c6035c7afbce.svg";